import { useContext, useState } from "react";
import { Box, Grid } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import CustomText from "../components/CustomText";
import ImageLoader from "../components/ImageLoader";
import { ScreenContext } from "../context/ScreenContext";

const CarruselHopitalization = () => {
  const { isMobile, isDesktop } = useContext(ScreenContext);

  const [index, setIndex] = useState(0);

  const prevCard = () => {
    setIndex((prev) => (prev - 1 + cards.length) % cards.length);
  };

  const currentCard = cards[index];

  return (
    <Grid container sx={design.Direction}>
      <Box style={design.Box}>
        {!isMobile && (
          <Box style={design.Cursor}>
            <CustomText
              variant="subtitle1"
              color="#2349D0"
              text="Donde la familia es nuestra prioridad"
              onClick={prevCard}
              sx={design.TextSig}
            >
              <ArrowBack sx={design.Margin} /> Anterior
            </CustomText>
          </Box>
        )}

        <Box style={design.BoxPrincipal}>
          <ImageLoader
            src={currentCard.image}
            alt={currentCard.image}
            width={"100%"}
            height={isMobile ? 350 : 720}
          />
          <CustomText
            variant="subtitle1"
            color="#333333"
            text="Donde la familia es nuestra prioridad"
            sx={design.Title}
          >
            {currentCard.title}
          </CustomText>
        </Box>
        {!isMobile && (
          <Box style={design.Sig}>
            <CustomText
              variant="subtitle1"
              color="#2349D0"
              text="Donde la familia es nuestra prioridad"
              onClick={prevCard}
              sx={design.TextSig}
            >
              Siguiente <ArrowForward sx={design.Arrow} />
            </CustomText>
          </Box>
        )}
      </Box>
        {isMobile && (
          <Grid container pt={3} gap={2}>
            <CustomText
              variant="subtitle1"
              color="#2349D0"
              text="Donde la familia es nuestra prioridad"
              onClick={prevCard}
              sx={design.TextSig}
            >
              <ArrowBack sx={design.Margin} /> Anterior
            </CustomText>
            <CustomText
              variant="subtitle1"
              color="#2349D0"
              text="Donde la familia es nuestra prioridad"
              onClick={prevCard}
              sx={design.TextSig}
            >
              Siguiente <ArrowForward sx={design.Arrow} />
            </CustomText>
          </Grid>
        )}
    </Grid>
  );
};
export default CarruselHopitalization;
const design = {
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 45,
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: "1%",
    textAlign: "center",
  },
  Direction: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 5,
  },
  Box: {
    position: "relative",
    marginTop: 10,
  },
  Cursor: {
    position: "absolute",
    left: "-200px",
    zIndex: 2,
    cursor: "pointer",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
  },
  TextSig: {
    display: "flex",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 16,
    lineHeight: "normal",
    textAlign: "center",
    fontWeight: 400,
  },
  Margin: { marginRight: 1 },
  prevColor: {
    position: "absolute",
    top: "20px",
    bottom: "0px",
    left: "-50px",
    right: "60%",
    borderRadius: "24px",
    zIndex: 0,
    transition: "background-color 0.3s ease",
  },
  nextColor: {
    position: "absolute",
    top: "20px",
    bottom: "0px",
    left: "60%",
    right: "-50px",
    borderRadius: "24px",
    zIndex: 0,
    transition: "background-color 0.3s ease",
  },
  BoxPrincipal: {
    position: "relative",
    zIndex: 1,
    padding: "15px",
    borderRadius: 15,
    height: "100%",
  },
  Sig: {
    position: "absolute",
    top: "0%",
    right: "-200px",
    zIndex: 2,
    cursor: "pointer",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
  },
  Arrow: { marginLeft: 1 },
};
const cards = [
  // {
  //   title: "Urgencias",
  //   image:
  //     "https://centromedicomedam.com/IMG/centromedicoMEDAM/Urgencias_del_centro-medico_MEDAM.png",
  // },
  {
    title: "Laboratorio",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/recepcion_laboratorio_del_centro-medico_MEDAM.png",
  },
  {
    title: "Cafetería",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/cafeteria_del_centro-medico_MEDAM.png",
  },
];
